import React, { useEffect, useState } from "react";
import PageContent from "../../components/layout/PageContent";
import axios from "axios";
import CustomForm from "../../components/form/CustomForm";
import { useHistory } from "react-router";

const AddAccessItem = () => {
  const [fields, setFields] = useState([]);
  const [loadingFields, setLoadingFields] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setLoadingFields(true);
    axios
      .get(`/api/1.0/accessitem`)
      .then(({ data = {} }) => {
        const { result = [] } = data;
        setFields(result);
      })
      .catch((err) => {
        console.error('Fetch Access Item Fields: ', err);
      })
      .finally(() => setLoadingFields(false));
  }, []);

  const handleSubmit = (values) => {
    return axios
      .post(`/api/1.0/accessitem`, values)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          history.push("/accessitem");
        }
      })
      .catch((err) => {
        console.error('Create Access Item: ', err);
      });
  };

  const handleCancel = () => {
    history.push("/accessitem");
  };

  return (
    <PageContent
      background="#fff"
      subheader={{
        title: "Хандах эрх үүсгэх",
        background: "#ffffff",
      }}
    >
      <CustomForm
        fields={fields}
        loading={loadingFields}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </PageContent>
  );
};

export default AddAccessItem;
